export const auth = {
    namespaced: true,
    state: {
        /** 登录中的用户信息 */
        currentUser: {
            memberId: null,
            sub: null,
            username: null,
            email: null,
            nickname: null,
            avatarUrl: null,
            isAuthenticated: false
        }
    },
    mutations: {
        /** 设定登录用户的信息 */
        setCurrentUser(state, payload) {
            state.currentUser = payload;
        }
    }
}
